// src/components/Header/Header.jsx (your latest version)
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { useAuth } from '../../context/AuthContext'; // ← import
import { useLanguage } from '../../i18n';
import styles from './Header.module.css';
import Logo  from "../../Images/AULOGO.png";

export default function Header() {
  const { currentUser, logout, isAdmin } = useAuth(); // ← get auth state
  const { lang, setLang, t } = useLanguage();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const handleLogout = async () => {
    await logout();
    closeMenu();
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        {/* Logo */}
        {/* <Link to="/" className={styles.logo} onClick={closeMenu}>
          <Icon icon="fa-solid:shield-alt" className={styles.logoIcon} />
          <span className={styles.logoText}>SafeGuard Resource Hub</span>
        </Link> */}
        <Link to="/" className={styles.logo} onClick={closeMenu}>
          <img
            src={Logo}
            alt="SafeGuard Logo"
            className={styles.logoImage}
          />
          {/* <span className={styles.logoText}>SafeGuard Resource Hub</span> */}
        </Link>

        {/* Desktop Navigation */}
        <nav className={`${styles.nav} ${styles.navDesktop}`}>
          <div className={styles.dropdown}>
            <button
              className={`${styles.navLink} ${styles.dropdownToggle}`}
              onMouseEnter={() => setIsResourcesOpen(true)}
              onMouseLeave={() => setIsResourcesOpen(false)}
            >
              {t('resources')}
              <Icon icon="lucide:chevron-down" className={styles.chevron} />
            </button>

            {isResourcesOpen && (
              <div
                className={styles.dropdownMenu}
                onMouseEnter={() => setIsResourcesOpen(true)}
                onMouseLeave={() => setIsResourcesOpen(false)}
              >
                <Link to="/collections" onClick={closeMenu}>{t('allCollections')}</Link>
                <Link to="/collections?category=digital" onClick={closeMenu}>{t('digitalSecurity')}</Link>
                <Link to="/collections?category=legal" onClick={closeMenu}>{t('legalAdvocacy')}</Link>
                <Link to="/collections?category=mental-health" onClick={closeMenu}>{t('mentalHealth')}</Link>
                <Link to="/collections?category=emergency" onClick={closeMenu}>{t('emergencyProtocols')}</Link>
                <Link to="/submit-resource" onClick={closeMenu}>{t('submitResource')}</Link>
                {isAdmin && (
                  <Link to="/admin/dashboard" onClick={closeMenu}>
                    {t('adminDashboard')}
                  </Link>
                )}
              </div>
            )}
          </div>

          <Link to="/search" className={`${styles.navLink} ${isActive('/search') ? styles.active : ''}`}>
            {t('search')}
          </Link>

          {currentUser ? (
            <>
              <Link to="/my-resources" className={`${styles.navLink} ${isActive('/my-resources') ? styles.active : ''}`}>
                {t('myResources')}
              </Link>
              <Link to="/support" className={`${styles.navLink} ${isActive('/support') ? styles.active : ''}`}>
                {t('supportDirectory')}
              </Link>
            </>
          ) : null}
        </nav>

        {/* Right side */}
        <div className={styles.rightActions}>
          <select
            value={lang}
            onChange={(e) => setLang(e.target.value)}
            className={styles.langSelect}
            aria-label="Language"
          >
            <option value="en">English</option>
            <option value="fr">Français</option>
            <option value="ar">العربية</option>
            <option value="pt">Português</option>
          </select>

          {currentUser ? (
            <>
              <Link to="/account-settings" className={styles.userAvatarLink}>
                <img
                  src={currentUser.photoURL || "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80"}
                  alt="User"
                  className={styles.avatar}
                />
              </Link>

              <Link to="/support" className={styles.emergencyBtn}>
                <Icon icon="lucide:phone" />
                <span>{t('emergency')}</span>
              </Link>

              <button className={styles.hamburger} onClick={toggleMenu} aria-label="Toggle menu">
                <Icon icon={isMenuOpen ? "lucide:x" : "lucide:menu"} />
              </button>
            </>
          ) : (
            <Link to="/login" className={styles.signInBtn}>
              {t('signIn')}
            </Link>
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className={styles.mobileMenu} onClick={closeMenu}>
          <div className={styles.mobileMenuInner} onClick={(e) => e.stopPropagation()}>
            {currentUser ? (
              <div className={styles.mobileUser}>
                <img
                  src={currentUser.photoURL || "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80"}
                  alt="User"
                />
                <div>
                  <strong>{currentUser.displayName || 'User'}</strong>
                  <span>{userRole}</span>
                </div>
              </div>
            ) : null}

            <div className={styles.mobileNav}>
              <div className={styles.mobileDropdown}>
                <button
                  className={styles.mobileDropdownToggle}
                  onClick={() => setIsResourcesOpen(!isResourcesOpen)}
                >
                  Resources
                  <Icon icon={isResourcesOpen ? "lucide:chevron-up" : "lucide:chevron-down"} />
                </button>

                {isResourcesOpen && (
                  <div className={styles.mobileDropdownContent}>
                      <Link to="/collections" onClick={closeMenu}>{t('allCollections')}</Link>
                      <Link to="/collections?category=digital" onClick={closeMenu}>{t('digitalSecurity')}</Link>
                      <Link to="/collections?category=legal" onClick={closeMenu}>{t('legalAdvocacy')}</Link>
                      <Link to="/collections?category=mental-health" onClick={closeMenu}>{t('mentalHealth')}</Link>
                      <Link to="/collections?category=emergency" onClick={closeMenu}>{t('emergencyProtocols')}</Link>
                      <Link to="/submit-resource" onClick={closeMenu}>{t('submitResource')}</Link>
                    {isAdmin && (
                      <Link to="/admin/dashboard" onClick={closeMenu}>
                          {t('adminDashboard')}
                      </Link>
                    )}
                  </div>
                )}
              </div>

              <Link to="/search" onClick={closeMenu}>Search</Link>

              {currentUser ? (
                <>
                      <Link to="/my-resources" onClick={closeMenu}>{t('myResources')}</Link>
                      <Link to="/support" onClick={closeMenu}>{t('supportDirectory')}</Link>
                      <Link to="/account-settings" onClick={closeMenu}>{t('accountSettings')}</Link>
                  <button onClick={handleLogout} className={styles.mobileSignOut}>
                        {t('signOut')}
                  </button>
                </>
              ) : (
                <Link to="/login" onClick={closeMenu}>{t('signIn')}</Link>
              )}

              <Link to="/support" className={styles.mobileEmergency} onClick={closeMenu}>
                <Icon icon="lucide:phone" />
                {t('emergency')}
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
// import { useState } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { Icon } from '@iconify/react';
// import styles from './Header.module.css';

// export default function Header() {
//   const location = useLocation();
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isResourcesOpen, setIsResourcesOpen] = useState(false);

//   const isActive = (path) => location.pathname === path;

//   const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
//   const closeMenu = () => setIsMenuOpen(false);

//   return (
//     <header className={styles.header}>
//       <div className={styles.container}>
//         {/* Logo */}
//         <Link to="/" className={styles.logo} onClick={closeMenu}>
//           <Icon icon="fa-solid:shield-alt" className={styles.logoIcon} />
//           <span className={styles.logoText}>SafeGuard Resource Hub</span>
//         </Link>

//         {/* Desktop Navigation – single line, no search */}
//         <nav className={`${styles.nav} ${styles.navDesktop}`}>
//           <div className={styles.dropdown}>
//             <button
//               className={`${styles.navLink} ${styles.dropdownToggle}`}
//               onMouseEnter={() => setIsResourcesOpen(true)}
//               onMouseLeave={() => setIsResourcesOpen(false)}
//             >
//               Resources
//               <Icon icon="lucide:chevron-down" className={styles.chevron} />
//             </button>

//             {isResourcesOpen && (
//               <div
//                 className={styles.dropdownMenu}
//                 onMouseEnter={() => setIsResourcesOpen(true)}
//                 onMouseLeave={() => setIsResourcesOpen(false)}
//               >
//                 <Link to="/collections" onClick={closeMenu}>All Collections</Link>
//                 <Link to="/collections?category=digital" onClick={closeMenu}>Digital Security</Link>
//                 <Link to="/collections?category=legal" onClick={closeMenu}>Legal & Advocacy</Link>
//                 <Link to="/collections?category=mental-health" onClick={closeMenu}>Mental Health</Link>
//                 <Link to="/collections?category=emergency" onClick={closeMenu}>Emergency Protocols</Link>
//                 <Link to="/submit-resource" onClick={closeMenu}>Submit New Resource</Link>
//               </div>
//             )}
//           </div>

//           <Link to="/search" className={`${styles.navLink} ${isActive('/search') ? styles.active : ''}`}>
//             Search
//           </Link>

//           <Link to="/my-resources" className={`${styles.navLink} ${isActive('/my-resources') ? styles.active : ''}`}>
//             My Resources
//           </Link>

//           <Link to="/support" className={`${styles.navLink} ${isActive('/support') ? styles.active : ''}`}>
//             Support Directory
//           </Link>
//         </nav>

//         {/* Right side: User avatar + Emergency (no search, no username text) */}
//         <div className={styles.rightActions}>
//           <Link to="/account-settings" className={styles.userAvatarLink}>
//             <img
//               src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80"
//               alt="User"
//               className={styles.avatar}
//             />
//           </Link>

//           <Link to="/support" className={styles.emergencyBtn}>
//             <Icon icon="lucide:phone" />
//             <span>Emergency</span>
//           </Link>

//           {/* Hamburger (mobile only) */}
//           <button className={styles.hamburger} onClick={toggleMenu} aria-label="Toggle menu">
//             <Icon icon={isMenuOpen ? "lucide:x" : "lucide:menu"} />
//           </button>
//         </div>
//       </div>

//       {/* Mobile Menu Overlay */}
//       {isMenuOpen && (
//         <div className={styles.mobileMenu} onClick={closeMenu}>
//           <div className={styles.mobileMenuInner} onClick={(e) => e.stopPropagation()}>
//             <div className={styles.mobileNav}>
//               <div className={styles.mobileDropdown}>
//                 <button
//                   className={styles.mobileDropdownToggle}
//                   onClick={() => setIsResourcesOpen(!isResourcesOpen)}
//                 >
//                   Resources
//                   <Icon icon={isResourcesOpen ? "lucide:chevron-up" : "lucide:chevron-down"} />
//                 </button>

//                 {isResourcesOpen && (
//                   <div className={styles.mobileDropdownContent}>
//                     <Link to="/collections" onClick={closeMenu}>All Collections</Link>
//                     <Link to="/collections?category=digital" onClick={closeMenu}>Digital Security</Link>
//                     <Link to="/collections?category=legal" onClick={closeMenu}>Legal & Advocacy</Link>
//                     <Link to="/collections?category=mental-health" onClick={closeMenu}>Mental Health</Link>
//                     <Link to="/collections?category=emergency" onClick={closeMenu}>Emergency Protocols</Link>
//                     <Link to="/submit-resource" onClick={closeMenu}>Submit New Resource</Link>
//                   </div>
//                 )}
//               </div>

//               <Link to="/search" onClick={closeMenu}>Search</Link>
//               <Link to="/my-resources" onClick={closeMenu}>My Resources</Link>
//               <Link to="/support" onClick={closeMenu}>Support Directory</Link>

//               <Link to="/account-settings" className={styles.mobileUser} onClick={closeMenu}>
//                 <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80" alt="User" />
//                 <span>Account Settings</span>
//               </Link>

//               <Link to="/support" className={styles.mobileEmergency} onClick={closeMenu}>
//                 <Icon icon="lucide:phone" />
//                 Emergency Help
//               </Link>
//             </div>
//           </div>
//         </div>
//       )}
//     </header>
//   );
// }
// import { useState } from 'react';
// import { NavLink, useLocation } from 'react-router-dom';
// import { Icon } from '@iconify/react';
// import styles from './Header.module.css';

// export default function Header() {
//   const location = useLocation();
//   const [search, setSearch] = useState('');

//   const isActive = (path) => location.pathname === path;

//   return (
//     <header className={styles.header}>
//       <nav className={styles.nav}>
//         {/* Logo */}
//         <div className={styles.logoContainer}>
//           <div className={styles.logoIconWrapper}>
//             <Icon icon="fa-solid:shield-alt" className={styles.logoIcon} />
//           </div>
//           <span className={styles.logoText}>SafeGuard Resource Hub</span>
//         </div>

//         {/* Search */}
//         <div className={styles.searchContainer}>
//           <input
//             type="text"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Search resources, collections, bookmarks..."
//             className={styles.searchInput}
//           />
//           <Icon icon="lucide:search" className={styles.searchIcon} />
//         </div>

//         {/* Links + Actions */}
//         <div className={styles.navLinks}>
//           <NavLink
//             to="/search"
//             className={`${styles.navLink} ${isActive('/search') ? styles.navLinkActive : ''}`}
//           >
//             Browse Resources
//           </NavLink>

//           <NavLink
//             to="/support"
//             className={`${styles.navLink} ${isActive('/support') ? styles.navLinkActive : ''}`}
//           >
//             Support Directory
//           </NavLink>

//           <NavLink
//             to="/my-resources"
//             className={`${styles.navLink} ${isActive('/my-resources') ? styles.navLinkActive : ''}`}
//           >
//             My Resources
//           </NavLink>

//           {/* Emergency button */}
//           <button className={styles.emergencyBtn}>
//             <Icon icon="lucide:phone" />
//             <span>Emergency</span>
//           </button>

//           {/* User */}
//           <div className={styles.userContainer}>
//             <img
//               src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80"
//               alt="User"
//               className={styles.avatar}
//             />
//             <span>Sarah Chen</span>
//             <Icon icon="lucide:chevron-down" />
//           </div>
//         </div>
//       </nav>
//     </header>
//   );
// }